import { StringBoolean } from "@/models/enum/stringBoolean";
import { AnswerPerson, Person } from "@/models/persons/person";

export class KeyPersonnel extends Person {
  pep: string;
  pepPosition: string;
  pepCountry: string;

  constructor(keyPersonnel?: AnswerKeyPersonnel) {
    super(keyPersonnel);
    if (keyPersonnel == undefined) {
      this.pep = "";
      this.pepPosition = "";
      this.pepCountry = "";
    } else {
      this.pep = keyPersonnel.pep;
      this.pepPosition = keyPersonnel.pepPosition;
      this.pepCountry = keyPersonnel.pepCountry;
    }
  }

  setPep(pepValue: string): void {
    this.pep = pepValue;
    if (pepValue != StringBoolean.Yes) {
      this.pepPosition = "";
      this.pepCountry = "";
    }
  }

  toAnswerModel(): AnswerKeyPersonnel {
    return new AnswerKeyPersonnel(this);
  }
}

export class AnswerKeyPersonnel extends AnswerPerson {
  pep: string;
  pepPosition: string;
  pepCountry: string;

  constructor(keyPersonnel: KeyPersonnel) {
    super(keyPersonnel);
    this.pep = keyPersonnel.pep;
    this.pepPosition = keyPersonnel.pepPosition;
    this.pepCountry = keyPersonnel.pepCountry;
  }
}
